import React, { useEffect } from 'react';

const MaintainAble = () =>{


    const color= "#abcfe6";


   useEffect(() => {
    document.querySelector('#outer-main').style.display="none"
    document.body.style.backgroundColor = color ;
}, []);



    return (
<>

       
<section id="subViews">

<div><img src="/assets/images/front-maintainable-link.png" alt="img" /></div>
<div className="children">
    <div className="sub-headline">Keeping your all upto data...</div>
    <div className="sub-text-maintain">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div>
    <div id="bottom"><div>maintainAble</div></div>
    </div>
</section>
</>


    );


}

export default MaintainAble;